const name = "auth";
export default name;
